/**
 * Derives the viewport search mode from the store values.
 *
 * The mode is never stored, so it cannot drift from the location type or the
 * focused-search flag.
 *
 * @module searchResultsMap/services/deriveViewportSearchMode
 */

import { RECTANGULAR_AREA, STATE } from '../constants';
import ViewportSearchMode from '../enums/viewportSearchMode';

/**
 * @param {{ locationType: string, focusedSearchActive: boolean }} values
 * @returns {ViewportSearchMode}
 */
export default function deriveViewportSearchMode({ locationType, focusedSearchActive }) {
  if (locationType === RECTANGULAR_AREA) {
    return ViewportSearchMode.RectangularArea;
  }

  if (focusedSearchActive === true) {
    return ViewportSearchMode.Focused;
  }

  if (locationType === STATE) {
    return ViewportSearchMode.StateViewport;
  }

  return ViewportSearchMode.Location;
}
